<div class="container_width">
  <div class="grid relative">

    <div class="col-12 md:col-3">
      <div class="sticky top-0 z-1" style="top: 2rem;">
        <div class="text-xl font-bold text-900 mb-3 px-2">Playlists</div>
        
        @if (isLoadingPlaylists()) {
          <div class="flex flex-column gap-2">
            <p-skeleton height="3rem" styleClass="w-full"></p-skeleton>
            <p-skeleton height="3rem" styleClass="w-full"></p-skeleton>
            <p-skeleton height="3rem" styleClass="w-full"></p-skeleton>
          </div>
        }

        <div class="flex flex-column gap-2 overflow-y-auto playlist-list-container">
          
          @for (item of playlists(); track item.id) {
            <div 
              pRipple
              (click)="onPlaylistSelect(item)"
              class="flex align-items-center p-3 border-round cursor-pointer transition-colors transition-duration-150 border-1"
              [class.surface-card]="selectedPlaylist().id !== item.id"
              [class.surface-border]="selectedPlaylist().id !== item.id"
              [class.playlist-item-selected]="selectedPlaylist().id === item.id"
              [class.playlist-item-selected]="selectedPlaylist().id === item.id"
              [class.playlist-item-selected]="selectedPlaylist().id === item.id">
              
              <i class="pi pi-list mr-3 text-lg" 
                 [class.playlist-item-selected]="selectedPlaylist().id !== item.id"
                 [class.playlist-item-selected]="selectedPlaylist().id === item.id"></i>
              
              <div class="flex-grow-1 overflow-hidden">
                <div class="font-medium white-space-nowrap overflow-hidden text-overflow-ellipsis">
                  {{ item.title }}
                </div>
              </div>

              @if (selectedPlaylist().id === item.id) {
                <i class="pi pi-chevron-right text-xs"></i>
              }
            </div>
          }

          @if (isLoadingMorePlaylists()) {
            <div class="flex justify-content-center py-2">
              <i class="pi pi-spin pi-spinner text-primary"></i>
            </div>
          }

          <div #playlistScrollAnchor style="height: 5px;"></div>
        </div>

      </div>
    </div>

    <div class="mt-5 col-12 md:col-9">
      
      <!-- <div class="surface-card p-4 border-round border-1 mb-4">
        <div class="font-bold text-xl text-900 mb-2">
          {{ selectedPlaylist()?.title || 'Loading...' }}
        </div>
        <div class="text-sm text-900 mb-2">
          {{ selectedPlaylist()?.description || 'Loading...' }}
        </div>
      </div> -->

      <div class="grid">
        
        @if (isLoadingVideos()) {
          @for (item of skeletonItems; track $index) {
            <div class="col-12 lg:col-4">
              <div class="w-full h-full flex flex-column bg-white border-round-lg border-1" style="border-color: #D0D0DD;">
                <div class="w-full flex align-items-center justify-content-center border-bottom-1 border-round-top-lg overflow-hidden" style="background-color: #F6F8FF; aspect-ratio: 16 / 9; border-color: #D0D0DD;">
                  <p-skeleton width="100%" height="100%" />
                </div>
                <div class="w-full flex flex-column align-items-start gap-3 p-3">
                  <p-skeleton width="100%" height="1.5rem" styleClass="mb-2" />
                  <div class="flex align-items-center gap-2">
                    <p-skeleton shape="circle" size="22px" />
                    <p-skeleton width="8rem" height="1rem" />
                  </div>
                  <div class="w-full mt-1">
                    <p-skeleton width="100%" height="3rem" borderRadius="8px" />
                  </div>
                </div>
              </div>
            </div>
          }
        }

        @for (video of videos(); track video.id) {
          <div class="col-12 lg:col-4">
            <div class="w-full h-full flex flex-column bg-white border-round-lg border-1" style="border-color: #D0D0DD;">
              
              <div class="w-full flex align-items-center justify-content-center border-bottom-1 border-round-top-lg overflow-hidden" style="background-color: #F6F8FF; aspect-ratio: 16 / 9; border-color: #D0D0DD;">
                <img [src]="video.thumbnailUrl" [alt]="video.title" style="width:100%; height: 100%; object-fit: cover;" onerror="this.src='../../../../assets/images/slider-image.jpg'">
              </div>

              <div class="w-full flex flex-column align-items-start gap-3 p-3">
                <b class="w-full text-left font-bold text-lg" style="color: #212022;">{{ video.title }}</b>
                <div class="flex align-items-center gap-2">
                  <img src="../../../../assets/icons/calendar_icon.svg" alt="" style="width: 22px;">
                  <p class="text-left font-normal text-sm" style="color: #818088;">{{ formatDate(video.publishedAt ?? '') }}</p>
                </div>
                <div class="w-full mt-1">
                  <button class="w-full flex align-items-center justify-content-center gap-3 watchVideoBtn" (click)="openVideo(video)">
                    Watch Video
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      @if (isLoadingMoreVideos()) {
        <div class="col-12 lg:col-4">
          <div class="w-full h-full flex flex-column bg-white border-round-lg border-1" style="border-color: #D0D0DD;">
            <div class="w-full flex align-items-center justify-content-center border-bottom-1 border-round-top-lg overflow-hidden" style="background-color: #F6F8FF; aspect-ratio: 16 / 9; border-color: #D0D0DD;">
              <p-skeleton width="100%" height="100%" />
            </div>
            <div class="w-full flex flex-column align-items-start gap-3 p-3">
              <p-skeleton width="100%" height="1.5rem" styleClass="mb-2" />
              <div class="flex align-items-center gap-2">
                <p-skeleton shape="circle" size="22px" />
                <p-skeleton width="8rem" height="1rem" />
              </div>
              <div class="w-full mt-1">
                <p-skeleton width="100%" height="3rem" borderRadius="8px" />
              </div>
            </div>
          </div>
        </div>
      }

      <div #videoScrollAnchor style="height: 10px; margin-bottom: 20px;"></div>

      @if (!videoNextToken && !isLoadingVideos() && videos().length > 0) {
        <div class="text-center text-500 py-4">End of list</div>
      }
    </div>

  </div>
</div>

<p-dialog [(visible)]="displayVideoDialog" [modal]="true" [dismissableMask]="true"
    [style]="{width: '800px', 'max-width': '95vw'}" [header]="activeVideoTitle" (onHide)="onCloseVideo()">
    <div class="video-container" style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; border-radius: 8px;">
        <iframe *ngIf="safeVideoUrl" [src]="safeVideoUrl" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
        </iframe>
    </div>
</p-dialog>